export default __webpack_public_path__ + "static/media/throne_hd.6be3ea8d.webp";